import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import first from '../../assets/first.png';
import second from '../../assets/second.png';
import third from '../../assets/third.png';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import './Onboarding.css';
import { auth } from "../../firebase";
import { withStyles } from '@material-ui/core/styles';

const NextBtn = withStyles((theme) => ({
    root: {
        "border": "2.4px solid #000000",
        "background": "transparent",
        "font-family": "Rubik",
        "font-weight": "400",
        "font-size": "17px",
        "border-radius": "18px",
        "cursor": "pointer",
        "text-align": "center",
        "text-decoration": "none",
        "width": "180px",
        "height": "40px",
        '@media (max-width: 565px)': {
            "font-size": "15px",
            "width": "150px",
            height: "33.33px",
        },
        '@media (max-width: 385px)': {
            "font-size": "13px",
            "width": "120px",
            height: "26.67px",
        },
    },
}))(Button);


export default function Onboardings({ uid }) {
    const [open, setOpen] = React.useState(true);
    const [pos, setpos] = useState(1);
    const handleClose = () => {
        localStorage.setItem('signup', '0');
        localStorage.setItem(uid, 'secondtime');
        setOpen(false);
    };
    const move = () => {
        if (pos === 3) {
            handleClose();
        }
        else {
            if (pos === 1) {
                setpos(2);
            }
            else {
                setpos(3);
            }
        }
    }

    if (pos === 1) {
        return (
            <div className='onboarding'>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <div className="content">
                        {/* <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle> */}
                        <DialogContent>
                            {/* <DialogContentText id="alert-dialog-description">
                Let Google help apps determine location. This means sending anonymous location data to
                Google, even when no apps are running.
            </DialogContentText> */}
                            <img src={first} className='firstimg' />
                        </DialogContent>
                        <div>
                            <FiberManualRecordIcon className='dot' onClick={(e) => setpos(1)} style={{ cursor: 'pointer' }} />
                            <FiberManualRecordIcon className='dot' color='disabled' onClick={(e) => setpos(2)} style={{ cursor: 'pointer' }} />
                            <FiberManualRecordIcon className='dot' color='disabled' onClick={(e) => setpos(3)} style={{ cursor: 'pointer' }} />
                        </div>
                        <NextBtn onClick={move}>Next</NextBtn>
                        <DialogActions>
                            {/* <Button onClick={handleClose} color="primary">
                Disagree
            </Button>
            <Button onClick={handleClose} color="primary" autoFocus>
                Agree
            </Button> */}
                        </DialogActions>
                    </div>

                </Dialog>
            </div>
        );
    }
    else if (pos === 2) {
        return (
            <div className='onboarding'>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <div className="content">

                        {/* <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle> */}
                        <DialogContent>
                            {/* <DialogContentText id="alert-dialog-description">
                    Let Google help apps determine location. This means sending anonymous location data to
                    Google, even when no apps are running.
                </DialogContentText> */}
                            <img src={second} className='firstimg' />
                        </DialogContent>
                        <div>
                            <FiberManualRecordIcon className='dot' color='disabled' onClick={(e) => setpos(1)} style={{ cursor: 'pointer' }} />
                            <FiberManualRecordIcon className='dot' onClick={(e) => setpos(2)} style={{ cursor: 'pointer' }} />
                            <FiberManualRecordIcon className='dot' color='disabled' onClick={(e) => setpos(3)} style={{ cursor: 'pointer' }} />
                        </div>
                        <NextBtn onClick={move}>Next</NextBtn>
                        <DialogActions>
                            {/* <Button onClick={handleClose} color="primary">
                    Disagree
                </Button>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Agree
                </Button> */}
                        </DialogActions>
                    </div>
                </Dialog>
            </div>
        );
    }
    else {
        return (
            <div className='onboarding'>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <div className="content">
                        {/* <DialogTitle id="alert-dialog-title">{"Use Google's location service?"}</DialogTitle> */}
                        <DialogContent>
                            {/* <DialogContentText id="alert-dialog-description">
                    Let Google help apps determine location. This means sending anonymous location data to
                    Google, even when no apps are running.
                </DialogContentText> */}
                            <img src={third} className='firstimg' />
                        </DialogContent>
                        <div>
                            <FiberManualRecordIcon className='dot' color='disabled' onClick={(e) => setpos(1)} style={{ cursor: 'pointer' }} />
                            <FiberManualRecordIcon className='dot' color='disabled' onClick={(e) => setpos(2)} style={{ cursor: 'pointer' }} />
                            <FiberManualRecordIcon className='dot' onClick={(e) => setpos(3)} style={{ cursor: 'pointer' }} />
                        </div>
                        <NextBtn onClick={move}>Let's Go</NextBtn>
                        <DialogActions>
                            {/* <Button onClick={handleClose} color="primary">
                    Disagree
                </Button>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Agree
                </Button> */}
                        </DialogActions>
                    </div>
                </Dialog>
            </div>
        );
    }
}
